var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.781 5.57v.002L7.886 9.765a.706.706 0 01-1.054-.003.854.854 0 01.002-1.14L9.45 5.806H.745C.334 5.806 0 5.446 0 5c0-.446.334-.807.745-.807H9.45L6.835 1.378a.854.854 0 01-.003-1.14.706.706 0 011.054-.003l3.895 4.194a.854.854 0 010 1.142z",
    fill: "currentColor"
  })));
}

export default SvgArrow;